import React from 'react'

import Input from '@/atoms/Fields/Input'
import Address from '@/atoms/Fields/Address'
import Textarea from '@/atoms/Fields/Textarea'
import Select from '@/atoms/Fields/Select'
import Group from '@/atoms/Fields/Group'
import Search from '@/atoms/Fields/Search'
import Recaptcha from '@/atoms/Fields/Recaptcha'
import File from '@/atoms/Fields/File'

const Controller = (props) => {
  const { type } = props
  let ControllerField = null
  switch (type) {
    case 'text':
    case 'email':
    case 'checkbox':
    case 'date':
    case 'number':
    case 'hidden':
      ControllerField = <Input {...props} />
      break
    case 'search':
      ControllerField = <Search {...props} />
      break
    case 'address':
      ControllerField = <Address {...props} />
      break
    case 'textarea':
      ControllerField = <Textarea {...props} />
      break
    case 'select':
      ControllerField = <Select {...props} />
      break
    case 'radioGroup':
    case 'checkboxGroup':
      ControllerField = <Group {...props} />
      break
    case 'recaptcha':
      ControllerField = <Recaptcha {...props} />
      break
    case 'file':
      ControllerField = <File {...props} />
      break
    default:
      ControllerField =  null
  }

  return (
    ControllerField
  )
}

export default Controller
